document.addEventListener("DOMContentLoaded", () => {
	const MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 МБ
	const container = document.querySelector("#mfcf7_zl_multifilecontainer");

	if (!container) return;

	const findSizeTextElement = () => {
		const listItems = document.querySelectorAll(".complain-form__list-item");
		for (const item of listItems) {
			const text = item.textContent.trim();
			if (text.includes("Максимальный размер файла")) {
				return item;
			}
		}
		return null;
	};

	const checkFilesSize = () => {
		const fileInputs = container.querySelectorAll('input[type="file"]');
		let hasError = false;

		fileInputs.forEach((input) => {
			if (input.files && input.files.length > 0) {
				Array.from(input.files).forEach((file) => {
					if (file.size >= MAX_SIZE_BYTES) {
						hasError = true;
						return;
					}
				});
			}
			if (hasError) return;
		});

		return hasError;
	};

	const highlightError = (isError) => {
		const sizeTextElement = findSizeTextElement();
		if (!sizeTextElement) return;

		if (isError) {
			sizeTextElement.classList.add("complain-form__list-item--error");
		} else {
			sizeTextElement.classList.remove("complain-form__list-item--error");
		}
	};

	const validateFileSize = (e) => {
		const form = e.currentTarget || e.target.closest(".wpcf7-form") || e.target;
		if (!form || form.tagName !== "FORM" || !form.contains(container)) {
			highlightError(false);
			return;
		}

		const hasError = checkFilesSize();

		if (hasError) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			highlightError(true);

			const sizeTextElement = findSizeTextElement();
			if (sizeTextElement) {
				setTimeout(() => {
					sizeTextElement.scrollIntoView({
						behavior: "smooth",
						block: "nearest",
					});
				}, 100);
			}

			return false;
		}

		highlightError(false);
		return true;
	};

	const form = container.closest(".wpcf7-form");
	if (!form) return;

	form.addEventListener("submit", validateFileSize, true);

	container.addEventListener("change", (e) => {
		if (!e.target.matches('input[type="file"]')) return;
		const hasError = checkFilesSize();
		highlightError(hasError);
	});

	const initialCheck = checkFilesSize();
	if (initialCheck) {
		highlightError(true);
	}
});
